// Собирает подписи отмеченных пунктов блока "Выберите ваш запрос" прямо из разметки:
// на каждой странице этот блок подключает свои переводы, поэтому брать их из фиксированных
// ключей локали нельзя.
export function getSelectedQueryItems() {
  const checkboxes = document.querySelectorAll('.main_query_selection__checkbox');

  return Array.from(checkboxes)
    .filter((checkbox) => checkbox.checked)
    .map((checkbox) => {
      const label = checkbox.closest('.main_query_selection__label');
      const text = label ? label.querySelector('.main_query_selection__text') : null;

      return text ? text.textContent.trim() : '';
    })
    .filter(Boolean);
}
